export enum PERMISSIONS {
  PatientView = 'PatientView',
  PatientCreate = 'PatientCreate',
  PatientEdit = 'PatientEdit',
  PatientPin = 'PatientPin',
  QuestionireView = 'QuestionireView',
  QuestionireFillOut = 'QuestionireFillOut',
  QuestionResultView = 'QuestionResultView',
  QuestionResultAcknowledgement = 'QuestionResultAcknowledgement',
  PatientGroupView = 'PatientGroupView',
  PatientGroupCreateAndEdit = 'PatientGroupCreateAndEdit',
  PatientGroupAssignUser = 'PatientGroupAssignUser',
  UserAdmin = 'UserAdmin',
  RoleAdmin = 'RoleAdmin',
  ViewAllPatient = 'ViewAllPatient',
  ManagentAllPatient = 'ManagentAllPatient',
  MobileAccess = 'MobileAccess',
  ClinicianPortalAccess = 'ClinicianPortalAccess',

  PatientTransferShare = 'PatientTransferShare',
  PatientTransferEdit = 'PatientTransferEdit',
  PatientTransferView = 'PatientTransferView',
  PatientTransferPendingView = 'PatientTransferPendingView',
}
